"use strict";function componentPunchFromPartner$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.componentPunchFromPartner$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.pbp.componentPunchFromPartner";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.10"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.10"},_a)),exports.componentPunchFromPartner$=componentPunchFromPartner$,exports.default=componentPunchFromPartner$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/pbp/componentPunchFromPartner.js
// module id = 980
// module chunks = 106